/**
 * Lightweight in-memory log of recent network calls — useful for debugging
 * API responses without wiring up a full devtools panel. Keeps only the
 * most recent entries so it can't grow unbounded over a long session.
 */
const MAX_ENTRIES = 50;

export interface NetworkCallRecord {
  category: string;
  type: string;
  url: string;
  request?: unknown;
  response?: unknown;
  timestamp: number;
}

const recentCalls: NetworkCallRecord[] = [];

export function saveNetworkResult(
  category: string,
  type: string,
  url: string,
  request?: unknown,
  response?: unknown,
): void {
  recentCalls.push({ category, type, url, request, response, timestamp: Date.now() });
  if (recentCalls.length > MAX_ENTRIES) {
    recentCalls.shift();
  }

  if (import.meta.env.DEV) {
    console.debug(`[${category}:${type}]`, url, { request, response });
  }
}

export function getRecentNetworkCalls(): readonly NetworkCallRecord[] {
  return recentCalls;
}
